import React, { useEffect, useState } from "react";
import Colors from "../../../../stories/assets/Colors";
import Fonts from "../../../../stories/assets/Fonts";
import { Button } from "../../../../stories/Button/Button";
import {
  HeadingBg,
  TennisSport,
  SoccerSport,
  BaseballSport,
  SkatingSport,
  FootballSport,
  BasketballSport,
  GolfSport,
  logoColor,
} from "../../../../constant/imagePath";
import { Container } from "react-bootstrap";
import { BeforeLoginHeader } from "../../../../stories/BeforeLoginHeader/BeforeLoginHeader";
import { PlayCard } from "../../../../stories/PlayCard/PlayCard.jsx";
import classes from "./CoachingStartProfileSetup.module.css";
import { Row, Col } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import { MobileHeader } from "../../../../stories/MobileHeader/MobileHeader";
import { isMobileViewHook } from "../../../../CustomHooks/isMobileViewHook";

export default function CoachingStartProfileSetup() {
  const history = useHistory();
  const [selectedValue, setSelectedValue] = useState(null);
  const [isMobile, setIsMobile] = useState(false);
  const cards = [
    { title: "Tennis", icon: TennisSport },
    { title: "Soccer", icon: SoccerSport },
    { title: "Baseball", icon: BaseballSport },
    { title: "Skating", icon: SkatingSport },
    { title: "Football", icon: FootballSport },
    { title: "Basketball", icon: BasketballSport },
    { title: "Golf", icon: GolfSport },
  ];
  useEffect(() => {
    isMobileViewHook(setIsMobile);
  }, [window.innerWidth]);

  const titleStyle = isMobile
    ? { ...Fonts.h5, fontWeight: 400, padding: "4px 12px 10px 12px",width:'auto' }
    : { ...Fonts.h7, lineHeight: "24px", fontFamily: "inter-600",width:'100%' };

  const mainHeadingStyles = isMobile
    ? { ...Fonts.h1, fontSize: "29px", lineHeight: "36px" }
    : { ...Fonts.h1 };

  return (
    <>
      <style jsx>{`
        .${classes.startProfileBtnBox} {
          border-top: 1px solid
            ${isMobile ? Colors.neutralShadesOfGainsboro : "transparent"};
        }
      `}</style>
      <div className={`${[classes.coachingStartProfileSetup].join(" ")}`}>
        <Container fluid className={"p-0"}>
          <Row className="g-0">
            <div className={classes.padding}>
              {isMobile ? (
                <MobileHeader
                  isLogo={true}
                  isAvatar={false}
                  customStyle={{ paddingTop: "16px", paddingLeft: "16px" }}
                />
              ) : (
                <BeforeLoginHeader icon={logoColor} />
              )}
            </div>

            <Col md={12} className={classes.padding}>
              <p
                className={` ${[classes.heading].join(" ")}`}
                style={{
                  ...mainHeadingStyles,
                  color: Colors.neutralShadesOfNero,
                }}
              >
                What sport will you be
                <span className={classes.overlayImg}>
                  &nbsp;&nbsp;coaching?
                  {selectedValue == null && <img src={HeadingBg} />}
                  &nbsp;
                </span>
              </p>
            </Col>
            <Col md={12} className={classes.padding}>
              <div className={`${[classes.cardsContainer].join(" ")}`}>
                {cards?.map((item) => {
                  return (
                    <div className={`${[classes.card].join(" ")}`}>
                      <PlayCard
                        title={item.title}
                        icon={item?.icon}
                        iconStyle={{
                          width: isMobile ? "80px" : "96px",
                          height: isMobile ? "80px" : "96px",
                          marginBottom: !isMobile && "16px",
                        }}
                        customStyle={{
                          alignItems: isMobile ? "center" : "center",
                          justifyContent: isMobile && "unset",
                          flexDirection: isMobile && "row",
                        }}
                        titleStyle={{
                          marginLeft: isMobile && "24px",
                          ...titleStyle,
                        }}
                        value={""}
                        selectedData={selectedValue}
                        onClick={() => setSelectedValue(item?.title)}
                        showSelection={true}
                      />
                    </div>
                  );
                })}
              </div>
            </Col>

            <Col
              md={12}
              className={`${[
                classes.innerContainer,
                classes.startProfileBtnBox,
              ].join(" ")}`}
            >
              <Button
                label={"Start profile setup"}
                disabled={selectedValue?.length > 0 ? false : true}
                primary={true}
                size={"Large"}
                customStyle={{
                  width: isMobile ? "100%" : "205px",
                  height: "56px",
                }}
                onClick={() => history.push("/on-boarding")}
              />
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
}
